module.exports = __webpack_public_path__ + "img/product-cuishou.b7e1596c.svg";